<template>
    <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="obModal.titulo"></span>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="$root.isTouch" rounded outlined @click="close(false)">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Estado" color="textbox" readonly :value="obModal.estadoSiniestro"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="N° de Reclamo" color="textbox" readonly :value="obModal.nroReclamo"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4" v-if="_.toNumber(obModal.idEstadoSiniestro) == _.toNumber(parametros.id_estado_siniestro_aceptado)">
                                <v-text-field label="Fecha de Pago" color="textbox" readonly :value="obModal.fechaRespuesta"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4" v-else>
                                <v-text-field label="Fecha de Negación" color="textbox" readonly :value="obModal.fechaRespuesta"
                                    outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Valor Reclamo" color="textbox" readonly :value="obModal.valorReclamo"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Valor Pagado" color="textbox" readonly :value="obModal.valorPagado"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Valor Deducible" color="textbox" readonly :value="obModal.valorDeducible"
                                    outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-textarea filled label="Observacion" color="textbox" readonly :value="obModal.observacion"
                                    outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-list two-line subheader dense>
                                    <v-subheader inset>Documentos</v-subheader>

                                    <v-list-item
                                        v-for="item in listDocumentos"
                                        :key="item.title"
                                        dense
                                    >
                                        <v-list-item-avatar>
                                        <v-icon
                                            :class="[item.iconClass]"
                                            v-text="item.icon"
                                        ></v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.title"></v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                        <v-btn icon @click="ver(item)">
                                            <v-icon color="primary">visibility</v-icon>
                                        </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn outlined dense rounded class="mr-1" @click="close(false)">Cancelar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalInformeSiniestroComponent',
        inject:['close'],
        components:{
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        props:{
            open:{
                type:Boolean,
                default:false
            },
            obModal:{
                type:Object,
                default:{}
            },
            listDocumentos:{
                type:Array,
                default: () => []
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            }
        }),
        methods:{
            ver(v){
                if(!_.isUndefined(v)){
                    var error = 'E';

                    axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': v.path})
                         .then((r) => {
                             if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                             if(_.size(_.get(r,['data','data'],[])) == 0) { error= 'I'; throw 'Error al leer el archivo PDF.'; } 
                                 this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                 this.objPdf.titulo = v.title;
                                 this.objPdf.mostrar = true;
                         })
                         .catch((e) => {
                             mensajesAlerta(e,error);
                         });
                }
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf: this.cerrarModalPdf
            }
        }
    }
</script>
